import { render, staticRenderFns } from "./Markup.vue?vue&type=template&id=0e9fb524&scoped=true&"
import script from "./Markup.vue?vue&type=script&lang=js&"
export * from "./Markup.vue?vue&type=script&lang=js&"
import style0 from "./Markup.vue?vue&type=style&index=0&id=0e9fb524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9fb524",
  null
  
)

export default component.exports